






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { GeneralAgent } from '@/modules/GeneralAgent/interfaces/general-agent'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'

@Component({
  components: {
    AppSystemInfoCard
  }
})
export default class GeneralAgentDetailAdditional extends Vue {
  @Prop({ type: Object as () => GeneralAgent }) readonly generalAgent!: GeneralAgent
}
